(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rts-restock-message')) {
    customElements.define(
      'rts-restock-message',
      class RtsRestockMessage extends HTMLElement {
        connectedCallback() {
          this.productForm = this.closest('form[is="product-form"]');
          if (!this.productForm) return;

          this.onVariantChange = (event) => {
            this.hidden = !event.detail.variant || event.detail.variant.available;
          };
          this.productForm.addEventListener('variant:change', this.onVariantChange);
        }

        disconnectedCallback() {
          this.productForm?.removeEventListener('variant:change', this.onVariantChange);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
